module.exports = __webpack_public_path__ + "img/3.ce61aa78.png";